module.exports = __webpack_public_path__ + "static/media/elo.550c8e86.svg";